// extracted by mini-css-extract-plugin
export default {"container":"CollapsibleSection_container__3QDJ8","header":"CollapsibleSection_header__DeJy9","icon":"CollapsibleSection_icon__GDtX5","content":"CollapsibleSection_content__b7AHi"};